import PortfolioEmpty from 'organisms/Portfolio/PortfolioEmpty';
import React, { ReactNode } from 'react';

interface PortfolioWrapperProps {
  title: string;
  description: string;
  link?: string;
  linkText?: string;
  isEmpty?: boolean;
  children?: ReactNode;
}

const PortfolioWrapper = ({
  isEmpty,
  title,
  description,
  children,
  link = '/marketplace',
  linkText = 'Browse offerings'
}: PortfolioWrapperProps) => {
  return isEmpty ? (
    <PortfolioEmpty title={title} description={description} link={link} linkText={linkText} />
  ) : (
    <>{children}</>
  );
};

export default PortfolioWrapper;
